<template>
  <div class="appranking-page">
    <div class="ranking-block">
      <div class="ranking-head">
        <div class="frist-line">
          <div class="text">
            <div class="text-pram">发布人：</div>
            <div class="text-name">
              {{ info.content[0].dept_name }}|{{ info.content[0].login_name }}
            </div>
          </div>
          <div class="time">{{ info.content[0].fbsj }}</div>
        </div>
        <div class="second-line">
          <div class="second-line-text">收件人：{{ info.content[0].dept_names }}</div>
        </div>
      </div>
      <div class="table-block" @click="popu('close')" style="">
        <div class="html-data" v-html="info.content[0].content"></div>

        <!-- <div class="read-block">
          <div>93人已读</div>
        </div> -->
      </div>
    </div>

    <div class="fixed-bottom" v-show="!showpopu"  @click="popu('open')">
        <div class="">{{info.content[0].haveread.length}}人已读</div>
        <div class="see-block">
          <el-button
            class="see-block-button"
            type="primary"
            round
            >查看状况</el-button
          >
        </div>
      </div>

    <div class="see-result" v-show="showpopu">
      <div class="result-head">
        <div class="result-change">
          <div
            :class="[
              isseeblock ? 'result-change-pram-active' : '',
              'result-change-pram',
            ]"
            @click="changesee('1')"
          >
            已读{{ info.content[0].haveread.length }}
          </div>
          <div
            :class="[
              !isseeblock ? 'result-change-pram-active' : '',
              'result-change-pram',
            ]"
            @click="changesee('2')"
          >
            未读{{ info.content[0].noread.length }}
          </div>
        </div>
        <div class="icon" @click="popu('close')">
          <img class="icon-img" src="../../images/arrow-right-666.png" alt="" />
        </div>
      </div>
      <div class="seeed" v-show="isseeblock">
        <div
          v-for="(item, index) in info.content[0].haveread"
          :key="index"
          class="name-block"
        >
          {{ item.login_name }}
        </div>
      </div>
      <div class="seeed" v-show="!isseeblock">
        <div
          v-for="(item, index) in info.content[0].noread"
          :key="index"
          class="noread-name-block"
        >
          {{ item.login_name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import actions from "../../common/actions.js";
import util from "../../common/util.js";
export default {
  data() {
    return {
      info: {},
      isseeblock: true,
      showpopu:false,
    };
  },
    metaInfo: {
        meta: [
          {name:'viewport',content:"width=1000,initial-scale=0.38,user-scalable=yes"}
        ],
      },
  methods: {
    seeresult() {
      let obj = util.urlGet();
      // alert('userid:'+util.getLocalStorage('userid')+';id'+obj.id)
      let data = {
        id: obj.id,
        token: "clientjcfy",
      };
      let remote = actions.getAppRanking(data);
      remote.then((res) => {
        if (res.is_success == "yes") {
          this.info = res;
          console.log(res);
        }
      });
    },
    changesee(type) {
      console.log(type);
      if (type == "1") {
        this.isseeblock = true;
      }
      if (type == "2") {
        this.isseeblock = false;
      }
    },
    popu(type) {
      if (type == "open") {
        this.showpopu = true
      }
      if (type == "close") {
        this.showpopu = false
        this.isseeblock=true
      }
    },
  },
  mounted() {
    this.seeresult();
  },
};
</script>
<style lang="scss" scoped>
.appranking-page {
  background: #f8f8f8;
  min-height: calc(100vh);
  .ranking-block {
    margin: 0.2926rem 0.532rem;
    background: #ffffff;
    border-radius: 0.266rem;
    .ranking-head {
      border-bottom: 0.0266rem solid #bfbfbf;
      padding: 0.798rem 0.532rem 0.532rem 0.532rem;
      .frist-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .text {
          font-size: 0.7448rem;
          .text-pram {
            color: #4d4d4d;
            display: inline-block;
          }
          .text-name {
            color: #030303;
            display: inline-block;
          }
        }
        .time {
          font-size: 0.4788rem;
          color: #8c8c8c;
        }
      }
      .second-line {
        margin-top: 0.399rem;
        font-size: 0.532rem;
        color: #4d4d4d;
      }
    }
    .table-block {
      padding: 0.798rem 0.532rem 1.33rem 0.532rem;
      .table-title {
        font-size: 0.24rem;
        color: #323232;
      }
      .read-block {
        font-size: 0.532rem;
        color: #edb94c;
        margin-top: 0.532rem;
      }
      .html-data{
        /deep/ img{
          max-width: 100%;
        }
      }
     
    }
  }
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    padding-bottom: var(--iphonex-fix-bottom);
    background: #ffffff;
    width: 100%;
    font-size: 0.532rem;
    color: #edb94c;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 2.128rem;
    padding-left: 0.532rem;
    padding-right: 0.532rem;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
    .see-block {
      .see-block-button {
        font-size: 00.532rem;
        background: #edb94c;
        border: none;
        padding: 0.3192rem 0.6118rem;
      }
    }
  }
  .see-result {
    position: fixed;
    bottom: 0;
    padding-bottom: var(--iphonex-fix-bottom);
    background: #ffffff;
    width: 100%;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
    .result-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.862rem;
      border-bottom: 0.01rem solid #bfbfbf;
      .result-change {
        .result-change-pram {
          display: inline-block;
          font-size: 0.532rem;
          color: #333333;
          width: 3.458rem;
          text-align: center;
          line-height: 1.862rem;
        }
        .result-change-pram-active {
          color: #edb94c;
          border-bottom: 0.0532rem solid #edb94c;
        }
      }
    }
  }
  .seeed {
    height: 10.64rem;
    overflow: auto;
    .name-block {
      color: #ffffff;
      background: #edb94c;
      padding: 0.266rem 0.6384rem;
      display: inline-block;
      margin: 0.266rem;
      border-radius: 0.133rem;
      font-size: 0.6384rem;
    }
    .noread-name-block {
      color: #ffffff;
      background: #409eff;
      padding: 0.266rem 0.6384rem;
      display: inline-block;
      margin: 0.266rem;
      border-radius: 0.133rem;
      font-size: 0.6384rem;
    }
  }
}
.icon {
  .icon-img {
    width: 0.798rem;
    transform: rotate(90deg);
    margin-right: 0.798rem;
  }
}
.second-line-text{
  line-height:1.064rem;
}



</style>